/**
 * Quiet empty-thread copy while a support thread is bound and waiting for a nudge.
 */
export function ListeningEmptyHint({ className }: { className?: string }) {
  return (
    <p className={className} role="status">
      Listening… I’ll nudge when there’s a gap.
    </p>
  )
}
